/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { FiraSansBold } from "components/Text/Text";
import { Breakpoints } from "constants/Breakpoints";
import Colors from "constants/Colors";
import styled from "styled-components";

export const FilterContainer = styled.div`
&.filter-close {
  display: none;
}

&.filter-open {
  position: absolute;
  right: 0;
  top: 60px;
  background-color: ${Colors.WHITE};
  z-index: 10;
  padding: 15px;
  width: 350px;
  box-shadow: -5px 5px 20px -10px black;
  
  > div > div {
    background-color: ${Colors.WHITE};  
  }
}

@media (max-width: ${Breakpoints.md}) {
  &.filter-close {
    display: none;
  }

  &.filter-open {
    position: fixed;
    overflow-x: scroll;
    top: 0;
    height: 100%;
    left: 0;
    width: 100%;
    background-color: ${Colors.WHITE};
    z-index: 2000;
    padding: 10px;

    > div > div {
      background-color: ${Colors.WHITE};  
    }
  }
  
  .icon-close {
    position: absolute;
    top: 0;
    right: 0;
    margin: 10px 15px;
    font-size: 30px;
  }
}
`;

export const CalendarContainer = styled.div`
  position: absolute;
  margin: 4px;
  z-index: 55;
  top: 60px;
  right: 24px;
`;

export const MobileLabel = styled.span`
  font-weight: ${FiraSansBold};
  text-transform: uppercase;
  font-size: 16px;
  color: ${Colors.GREEN};
`;

export const FilterSearchContainer = styled.div`
  border-radius: 20px 20px 0 0;
  width: 100%;
  margin-bottom: 10px;
`;

export const RowFilterIcon = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: end;
  flex-direction: row;
  background-color: ${Colors.BLUE};
  border-radius: 20px 20px 0 0;
  margin-bottom: 10px;
  padding: 7px 10px;
  position: relative;

  @media (max-width: ${Breakpoints.md}) {
    border-radius: 10px 10px 0 0;
  }
`;

export const RowFilter = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  padding: 5px;
`;

export const CheckBoxColumn = styled.div`
  width: 20%;
`;

export const FilterColumn = styled.div`
  width: 100%;
`;

export const DialogSelect = styled.div`
  width: 100%;  
  margin: 30px 0px 10px 0px;
`;

export const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${Colors.BLUE};
  border: 0px;
  border-radius: 5px;
  font-weight: ${FiraSansBold};
  font-size: 14px;
  font-family: 'Fira Sans', sans-serif;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;


export const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: ${FiraSansBold};
  font-size: 14px;
  font-family: 'Fira Sans', sans-serif;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;